import { useMemo, type FC } from 'react';
import { PapiBadge, PapiUser } from '@wix/da-papi-types';
import ElementQueries from '@wix/da-shared-react/pkg/ElementQueries';
import classnames from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import CategoryBadgeBox from '../BadgeBox';
import { useTranslation } from 'react-i18next';
import shortenNumber from '@wix/da-ds/pkg/utils/shortenNumber';
import { BadgeCategoryType } from '../types';

import s from './BadgeCategory.scss';

export interface Props {
  category: BadgeCategoryType;
  badges: PapiBadge[];
  className?: string;
  profileOwnerUser: PapiUser;
  widthBreakpoints?: number[];
}

const BadgeCategory: FC<Props> = ({
  category,
  badges,
  className,
  widthBreakpoints,
  profileOwnerUser,
}) => {
  const { t } = useTranslation();

  const count = useMemo(() => {
    let num = 0;
    for (let i = 0; i < badges.length; i++) {
      const badge = badges[i];
      num += badge.stackCount;
    }
    return shortenNumber(num, 0);
  }, [badges]);

  return (
    <ElementQueries
      className={classnames(s['root'], className)}
      widthBreakpoints={widthBreakpoints || [640, 800]}
    >
      <Heading className={s['categoryTitle']}>
        {t(`widgets.badges.collections.name.${category}`)}&nbsp;&nbsp;&nbsp;
        {count}
      </Heading>
      <p className={s['categoryDescription']}>
        {t(`widgets.badges.collections.description.${category}`)}
      </p>
      <div className={s['badgeGridArea']}>
        {badges.map((badge, i) => (
          <CategoryBadgeBox
            key={i}
            badge={badge}
            className={s['grid-item']}
            profileOwnerUser={profileOwnerUser}
          />
        ))}
      </div>
    </ElementQueries>
  );
};
BadgeCategory.displayName = 'BadgeCategory';

export default BadgeCategory;
